/**
 * @module actions/signup
 */
import axios from 'axios'
import { API_URL } from '../constants'
import { setAuthorizationToken, setDeviceToken } from '../utils/setAuthorizationToken'

import { setCurrentUser } from './auth.js'

/**
 * @description Sends signup info
 * @return {Promise} Axios promise
 */
export function sendSignup (data) {
  let url = API_URL + '/Users/Free/Signup'
  return dispatch => {
    return axios.post(url, data).then(res => {
      const token = res.data.Token
      window.localStorage.setItem('user_token', token)
      window.localStorage.setItem('user_data', JSON.stringify(res.data))
      window.localStorage.setItem('user_language', 'English')
      setAuthorizationToken(token)
      setDeviceToken(res.data.DeviceToken)
      dispatch(setCurrentUser(res.data))
      return res
    })
  }
}

export function upgradeRequest (name, phone, userId) {
  let url = API_URL + '/Users/RequestPro'
  let data = {
    Name: name,
    PhoneNumber: phone,
    UserId: userId
  }
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/signup.js